module.exports = __webpack_public_path__ + "img/19_98.c27acdc8.png";